import type { ISoftware } from '@/models/software'
import { Software } from '@/models/software'
import softwareService from '@/services/software/software'
import { defineStore } from 'pinia'
import type { ISoftwareState } from './software.types'

export const useSoftwareStore = defineStore('software', {
  state: (): ISoftwareState => ({
    softwares: []
  }),
  
  getters: {
    getSoftwares(state: ISoftwareState): ISoftware[] {
      return state.softwares.map((software) => new Software(software))
    }
  },

  actions: {
    async fetchSoftwares() {
      const softwares = await softwareService.fetchSoftwares()
      this.softwares = softwares
    }
  }
})
